export const SOCURE_CODE_DESCRIPTIONS_LIST = {
  I610: "Phone number is correlated with the address",
  I704: "Address is multi-unit or high rise",
  I705: "Address is single unit",
  I706: "Address is an accredited college oruniversity",
  I707: "Address is residential",
  I708: "Address can be resolved to the individual",
  I711: "Address is confirmed as deliverable",
  I712: "Address is confirmed deliverable by dropping secondary information (apartment, unit, etc.)",
  I713: "Address is confirmed deliverable but was missing secondary information (apartment, unit, etc.)",
  I714: "Address is valid but doesn't currently receive US Postal Service street delivery",
  I715: "Address is correlated with a past address",
  I716: "Address is a Small Office/Home Office (SOHO)",
  I720: "Address risk score represents low risk",
  I721: "Email address is correlated with the input physical address",
  I722: "Email address is partially correlated with the input physical address",
  R601: "Phone number associated address is not correlated with the input address",
  R602: "Phone number associated address is not correlated with the input country",
  R607: "Phone number associated address is partially correlated with the input address",
  R701: "Address is inactive, not receiving mail or vacant",
  R702: "Address is not confirmed as deliverable",
  R703: "Address is invalid or does not exist",
  R704: "Address is a correctional facility",
  R705: "Address cannot be resolved to the individual",
  R707: "Address is a commercial mail receiving agency or commercial mail drop",
  R708: "Address is a PO Box",
  R709: "Address is commercial or dual-purpose",
  R710: "Address is a military location",
  R711: "Address is a unique ZIP code, or corporate only, routing all mail internally by the assigned organization rather than by the USPS",
  R712: "Address ZIP code is invalid",
  R713: "Address mismatch between city, state,and ZIP code",
  R714: "Address was fuzzy matched to the address on record",
  R720: "Address risk score represents high risk",
  R721: "Email address is not correlated with the input physical address",
  R722: "The input state or zip was corrected during address standardization",
  I709: "Address is correlated with the first name",
  I710: "Address is correlated with the last name",
  I718: "Exact match between address and first name",
  I719: "Exact match between address and last name",
  R110: "Alert List email address match",
  R111: "Alert List SSN/ITIN match",
  R113: "Alert List phone number match",
  I401: "Device token previously encountered",
  I402: "Multiple users associated with device",
  I403: "Identity may not be primary device user",
  I404: "Identity associated with primary device owner",
  I405: "Device token previously associated with phone number",
  I406: "Device token previously associated with email address",
  I407: "Device token previously associated with first name",
  I408: "Device token previously associated with last name",
  I409: "Device token not encountered within the past 5 days",
  I410: "Device session is associated with more than 2 phone numbers",
  I411: "Device session is associated with more than 2 emails",
  I412: "Device session is associated with more than 2 first names",
  I413: "Device session is associated with more than 2 last names",
  I414: "Session connected using a proxy",
  I415: "Session connected using an IP located more than 100 miles from the address",
  I416: "Session IP originates from within the United States",
  I417: "Session IP originates from outside the United States",
  I419: "Session connected using a residential IP address",
  I420: "Session connected using a commercial IP address",
  I421: "Session connected using a mobile IP address",
  I423: "Device is a physical device",
  I424: "The device type is a desktop or laptop computer",
  I425: "The device type is mobile, tablet or wearable",
  I631: "IP address is provided by a mobile carrier",
  I632: "IP Connection is consumer",
  I633: "IP Connection is business",
  I634: "IProxy is an educational institution",
  I635: "Proxy is registered to a corporation",
  I636: "IP address originates from the US or US territories",
  I638: "IP proxy is originating from Google or Apple consumer privacy networks",
  I639: "IP address is a consumer privacy network proxy",
  R401: "Device token was not previously encountered",
  R402: "Invalid device token",
  R403: "Device is a virtual device",
  R405: "The Device Risk module was called, but a device token was not provided",
  R406: "Device risk score represents high risk",
  R639: "IP address originates from outside of the US or US territories",
  R640: "IP address originates from an OFAC sanctioned country",
  R641: "Proxy is from services that change location to beat DRM, TOR points, temporary proxies and other masking services",
  R642: "IP address is associated with a cloud hosting provider and is likely a proxy. Users are not usually located in a hosting facility",
  R643: "IP address is associated with a location allowing public internet access",
  R644: "IP proxy is cloud-based",
  R645: "IP proxy is TOR-based",
  R646: "IP proxy is VPN-based",
  R647: "IP proxy is cloud-security-based",
  R650: "IP address is associated with an anonymizing proxy",
  R652: "IP address is associated with spam activity",
  R653: "IP address origin & usage indicates non-human traffic",
  I805: "Document resolutions insufficient for detailed analysis",
  I808: "Document image resolution is insufficient",
  I820: "Headshot passes integrity checks",
  I822: "First name extracted from document correlates with input name",
  I823: "Last name extracted from document correlates with input name",
  I824: "Address extracted from document correlates with input address",
  I825: "DOB extracted from document correlates with input DOB",
  I826: "Document number extracted from document correlates with input number",
  I831: "Minimum required information extracted from document Barcode",
  I832: "Document number consistent on front and back of document",
  I833: "Minimum required information extracted from document MRZ",
  I834: "Self-portrait passes liveness checks",
  I836: "Document image correlates with self-portrait",
  I837: "Self-portrait was not considered in decision",
  I838: "Minimum Required Information extracted from the document",
  I839: "Name extracted from document correlates with barcode and MRZ",
  I840: "Address extracted from document correlates with barcode and MRZ",
  I841: "DOB on document matches DOB on barcode or MRZ",
  I842: "Expiration date on document matches date on barcode or MRZ",
  I843: "Issue date on document matches date onbarcode or MRZ",
  I844: "Dates on document are valid",
  I845: "Age meets minimum requirements",
  I846: "Expired document within the grace period specified",
  I847: "Document about to expire within the future grace period",
  I848: "The document is not captured properly",
  I849: "Incorrect ID type selected",
  I854: "The back of the license was not passed; no barcode to extract information",
  I855: "First Name matches with a known Nick Name or Alias",
  I856: "Liveness was not determined",
  I860: "Facial correlation was not calculated",
  R804: "Document image doesn't meet the minimum color requirements",
  R810: "Document pattern and layout integrity check failed",
  R819: "Document submitted is captured from a digital screen",
  R820: "Document headshot has been modified",
  R822: "First name extracted from document does not match input first name",
  R823: "Last name extracted from document does not match input last name",
  R824: "Address extracted from document does not match input address",
  R825: "DOB extracted from document does not match input DOB",
  R826: "Document Number extracted from document does not match imput number",
  R827: "Document is expired",
  R831: "Cannot extract the minimum information from barcode",
  R832: "Document number extracted from front and back of document does not match",
  R833: "Cannot extract the minimum required information from MRZ",
  R834: "Self-portrait fails liveness check",
  R836: "Document image does not correlate with self-portrait",
  R838: "Minimum amount of information cannot be extracted from document",
  R839: "Name extracted from document does not match with barcode or MRZ",
  R840: "Address extracted from document does not match with barcode or MRZ",
  R841: "DOB on document does not match DOB on barcode or MRZ",
  R842: "Expiration date on document does not match date on barcode or MRZ",
  R843: "Issue date on document does not match date on barcode or MRZ",
  R844: "Dates on document are not valid",
  R845: "Minimum age criteria not met",
  R850: "Self-portrait or the headshot is not usable for Facial Match",
  R851: "Document number is an example number, and is not valid",
  R852: "Submitted document is a temporary ID",
  R853: "Unable to classify the ID or this is an unsupported ID type",
  R856: "Obstructions on the face affecting theliveness",
  R857: "No face found in the selfie frame",
  R858: "The age on the document doesn't correlate with the selfie predicted age",
  R859: "ID front correlates with another submitted ID front",
  R861: "Data extracted from document does not match with barcode or MRZ",
  R862: "Document returned as unknown classification",
  I998: "Name, SSN and DOB correlation verified by SSA",
  I999: "Identity decease unverified by SSA",
  R998: "Name, SSN and DOB correlation unverified by SSA",
  R999: "Identity decease verified by SSA",
  I520: "Email risk score represents low risk",
  I550: "Email address is more than 180 days and less than 1 year old",
  I551: "Email address is more than 1 year and less than 2 years old",
  I553: "Email address is more than 2 years old",
  I555: "Email address domain is more than 180 days old",
  I556: "Email address can be resolved to the individual",
  I560: "Email address domain represents a Fortune 500 company",
  I561: "Email address domain represents a US College/University",
  I562: "Email username contains ZIP code of current application",
  I563: "Email address domain contains a special use domain (RFC, arpa, example, invalid, local, onion, etc.)",
  I564: "Special characters which are not periods or underscores found in email alias",
  I565: "Email username contains a role-level alias (employees, support, info, postmaster, admin, user, noreply, etc.)",
  I566: "Email address provider is found in Public Web Source",
  I567: "Email username contains five or more alphabetic sections",
  I568: "Email handle contains a name",
  I569: "Email handle contains input first name",
  I570: "Email handle contains input surname",
  I637: "Email address is associated with the input phone number",
  R520: "Email risk score represents high risk",
  R551: "Email address is invalid",
  R557: "Email address is disposable",
  R558: "Email address is auto-generated",
  R559: "Email address cannot be resolved to the individual",
  R560: "Majority of characters in username are numbers",
  R561: "Email address is less than 180 days old",
  R562: "Email address domain is less than 180 days old",
  R563: "Email address domain is invalid",
  R564: "Email address username is invalid",
  R565: "Email address domain represents high risk",
  R566: "Email address has not been seen before",
  R567: "Email address top-level domain represents high risk",
  R568: "Email username appears to be scrambled",
  R569: "Email string is unusually long",
  R571: "Low activity observed on the email address in the last 180 days",
  R572: "Email associated with more than 2 phone numbers in the last 2 years",
  R573: "Email handle contains trigrams (groups of 3 consecutive letters) that have unusually low occurrence rates",
  R574: "Email handle is composed of more than 50% symbols (i.e. ._)",
  I554: "Exact match between email and first name",
  I557: "Email is correlated with the first name",
  I558: "Email is correlated with the last name",
  I559: "Exact match between email and last name",
  I350: "DOB indicates an age between 18 and 20",
  I351: "DOB indicates an age between 21 and 24",
  I352: "DOB indicates an age over 25",
  I903: "Address was not provided at input",
  I904: "SSN/TIN was not provided at input",
  I905: "SSN/ITIN provided at input contained only 4 digits",
  I906: "DOB was not provided at input",
  I907: "SSN is issued to a non-US citizen",
  I908: "Address is correlated with a military ZIP code",
  I909: "First name and last name are possibly reversed",
  I910: "Address is correlated with a past address",
  I911: "Address is a PO Box",
  I912: "SSN was randomly-issued by the SSA",
  I917: "Full name and address can be resolved to the individual but the SSN/ITIN is not",
  I919: "Full name, address, and SSN/ITIN can be resolved to the individual",
  I920: "Emerging identity indicator",
  I921: "Address is an accredited college or university",
  I930: "The name and DOB of the identity matches a notable personality/celebrity",
  I931: "First name or last name may refer to a non-person entity",
  R350: "DOB indicates individual is less than 16 or more than 100 years old",
  R351: "DOB indicates COPPA review",
  R352: "DOB indicates an age between 13 and 15",
  R353: "DOB indicates an age between 16 and 17",
  R354: "DOB indicates age is correlated with higher fraud rates",
  R901: "SSN/ITIN cannot be resolved to the individual",
  R902: "Name cannot be resolved to theindividual",
  R907: "SSN has been reported as deceased",
  R909: "Identity has been reported as deceased",
  R911: "SSN issued prior to DOB",
  R913: "SSN/ITIN is invalid",
  R916: "Address is invalid or does not exist",
  R919: "Address cannot be resolved to the individual",
  R922: "DOB cannot be resolved to the individual",
  R923: "SSN/ITIN was fuzzy matched to the SSN/ITIN on record",
  R924: "Address was fuzzy matched to the address on record",
  R927: "Name does not correlate with the name for the resolved individual",
  R928: "SSN/ITIN is associated with multiple last names",
  R930: "First name does not correlate with the first name for the resolved individual",
  R932: "Address is a correctional facility",
  R933: "Last name is not correlated with the SSN/ITIN on record",
  R934: "First name is not correlated with the SSN/ITIN on record",
  R939: "SSN/ITIN is correlated with the first name but not the last name",
  R940: "SSN/ITIN not found in public records",
  R941: "SSN/ITIN is correlated with at least 1 other name and address",
  R944: "Last name was fuzzy matched to the name on record",
  R946: "DOB was fuzzy matched to the DOB on record",
  R947: "SSN/ITIN is not the primary SSN/ITIN for the resolved identity",
  R948: "Address mismatch between city, state, and ZIP code",
  R953: "SSN was randomly-issued by the SSA and cannot be resolved to the individual",
  R954: "SSN/ITIN entered is an ITIN",
  R955: "SSN/ITIN is correlated to multiple identities",
  R956: "Identity is correlated to multiple SSN/ITINs",
  R957: "DOB is not on record and cannot be verified",
  R961: "Address ZIP code is invalid",
  R963: "Address ZIP code only serves PO Boxes",
  R964: "Address is a commercial or institutional address",
  R972: "Address is a commercial mail receiving agency or commercial mail drop",
  R973: "Address is a unique ZIP code, or corporate only, routing all mail internally by the assigned organization rather than by the USPS",
  R976: "Identity is associated with an active duty alert",
  R977: "Identity is associated with an active duty alert and a fraud victim initial alert",
  R978: "Identity is associated with a fraud victim initial alert",
  R979: "Identity is associated with an active duty alert and a fraud victim extended alert",
  R980: "Identity is associated with a fraud victim extended alert",
  I601: "Phone number is a landline",
  I602: "Phone number is a mobile line",
  I605: "Phone number is a Premium-rate line",
  I608: "Phone number is commercial or dual-purpose",
  I609: "Phone number is consumer or residential",
  I611: "Phone number is associated with a major US carrier",
  I614: "Phone number has been in service more than 365 days",
  I616: "Phone number is associated with a Mobile Virtual Network Operator",
  I618: "Phone number can be resolved to the individual",
  I620: "Phone risk score represents low risk",
  I625: "Phone number has never been ported",
  I626: "Phone number was ported at least 60 days ago",
  I630: "Phone subscriber has been correlated with the input phone number for more than 365 days",
  R603: "Phone number is invalid",
  R604: "Phone number has not been actively used within the past 90 days",
  R605: "Phone number has not been actively used for more than 90 days",
  R606: "Phone number is not actively used",
  R608: "Phone number cannot be resolved to the individual",
  R611: "Phone number is not allowed for consumers",
  R613: "Phone number is fixed or traditional VoIP",
  R614: "Phone number is toll-free",
  R615: "Phone number is non-fixed or over-the-top VoIP",
  R616: "Phone number is prepaid",
  R617: "Phone number is not associated with a major US carrier",
  R618: "Phone number has been in service between 90 and 365 days",
  R620: "Phone risk score represents high risk",
  R622: "Phone number has been in service between 7 and 30 days",
  R623: "Phone number has been in service between 30 and 90 days",
  R625: "Phone number has ported within the past 24 hours",
  R626: "Phone number has been ported within the past 2 to 7 days",
  R627: "Phone number has been ported within the past 7 to 30 days",
  R628: "Phone number has been ported within the past 30 to 60 days",
  R631: "Phone subscriber has been correlated with the input phone number for between 7 and 30 days",
  R632: "Phone subscriber has been correlated with the input phone number for between 30 and 90 days",
  R633: "Phone subscriber has been correlated with the input phone number for between 90 and 365 days",
  R648: "Phone number has had a name change in the last 3 days",
  R654: "Phone number seen in frozen credit files",
  R655: "Phone number was first seen less than 50 days ago",
  R656: "Phone number seen in credit files flagged as having initial fraud alerts",
  R657: "Input surname has not been associated with the phone number for more than 2 years",
  R658: "Input surname has not been primarily used with the phone number for more than 2 years",
  R659: "Phone number has been associated with more than two email addresses in the last 60 days",
  R661: "No inquiry was found against input phone number",
  R662: "Phone number was first seen less than sixty days ago within Socure network",
  I621: "Phone is correlated with the first name",
  I622: "Phone is correlated with the last name",
  I623: "Exact match between phone and first name",
  I624: "Exact match between phone and last name",
  I121: "Social networks match",
  I127: "Online sources are representative of a broader digital footprint than just social networks",
  I201: "Name, address, and SSN match",
  I202: "The input SSN is an ITIN",
  R201: "The input SSN is invalid",
  R202: "The input SSN is reported as deceased",
  R203: "Multiple identities associated with input SSN",
  R204: "Entered SSN associated with multiple last names",
  R205: "Entered SSN associated with different name and address",
  R206: "The input SSN was issued prior to the input date-of-birth",
  R207: "SSN/ITIN is associated with multiple DOBs",
  R208: "SSN/ITIN is associated with multiple addresses",
  R209: "No former addresses associated with the SSN",
  R210: "Frequency of SSN in Socure records is unusually high",
  R211: "SSN seen in frozen credit files",
  R212: "Surname is not associated with the SSN",
  R213: "Name does not correlate with the name for the resolved individual",
  R214: "Input SSN is not found in best-matched identity",
  R215: "First name is not associated with the SSN",
  R216: "Input DOB is not found in best-matched identity",
  R217: "SSN was randomly-issued by the SSA",
  R218: "Input SSN is not the primary SSN for the resolved identity",
  R219: "Input SSN is not found in public records",
  R298: "Identity resembles a manipulated Synthetic identity",
  R299: "Identity resembles a fabricated Synthetic identity",
  R610: "IP address geolocation places user more than 100 miles from address",
  R619: "IP address is a known proxy",
  R660: "Two or more addresses are marked ascurrent in the phone public records",
  I203: "SSN was first seen in credit header records between 5 to 10 years ago",
  I204: "SSN is first seen in credit header records more than 10 years ago",
  I205: "SSN is found to be inquired once every 2 to 3 months",
  I206: "SSN is found to be inquired once every 3 to 6 months",
  I207: "SSN is found to be inquired once every 6 to 12 months",
  I208: "SSN is found to be inquired less than once a year",
  R220: "Issue date for the provided SSN could not be resolved",
  R221: "SSN associated with input phone number could not be confirmed",
  R222: "Input SSN could not be confirmed",
  R223: "Input SSN did not match any of the SSNs associated with the input phone number in the last two years",
  R224: "4 or more different SSNs have been found to be inquired against the input phone",
  R225: "4 or more different first names have been found to be inquired against the input SSN",
  R226: "Multiple phones are marked current for the input SSN",
  R227: "SSN is found to be inquired at a very frequent rate of less than once a month",
  R228: "Only 1 component of the input DOB matches the best matched entity",
  R229: "Only 2 components of the input DOB matches the best matched entity",
  R230: "SSN was first seen in credit header records within the last 1 year",
  R231: "SSN was first seen in credit header records between 1 to 3 years ago",
  R232: "SSN was first seen in credit header records between 3 to 5 years ago",
  R233: "No SSN found in credit header records for the given full name and DOB",
  R234: "SSNs in credit header data associated with full name and DOB differ from input SSN by 1 digit",
  R235: "Input full name could not be fuzzy matched with full names associated with SSN in header and inquiry records",
  R236: "Input DOB month does not match any DOB month found on inquiry records",
  R237: "Input SSN does not match the SSN's associated with the given full name and DOB",
  R238: "SSNs in credit header data associated with full name and DOB differ from input SSN by up to 2 digits",
  R239: "SSNs in credit header data associated with full name and DOB differ from input SSN by up to 3 digits",
  I196: "Global Watchlist sources selected are not correlated with the input identifiers",
  R180: "Watchlist search returned at least one hit on OFAC SDN list",
  R181: "Watchlist search returned at least one hit on OFAC Non-SDN lists",
  R182: "Watchlist search returned at least one hit on a sanction list excluding any OFAC hits",
  R183: "Watchlist search returned at least one hit on an enforcement list excluding any OFAC hits",
  R184: "Watchlist search returned at least one hit on a politically exposed person",
  R185: "Watchlist search returned at least one entity that had adverse media articles",
  R186: "Global Watchlist sources selected are correlated with the input identifiers",
  R187: "Address resolves to a High-Intensity Drug Trafficking Area",
  R188: "Address resolves to a High-Intensity Financial Crime Area",
};
